<template>
  <div class="goods-view-container">
    <div class="content-area">
      <el-card class="table-card" shadow="always">
        <div class="card-header">
          <h3 class="card-title">
            <i class="el-icon-view"></i>
            商品详情查看
          </h3>
        </div>
        <div class="table-section">
          <!-- 筛选条件和搜索区域 -->
          <div class="filter-header">
            <div class="filter-section">
              <h4 class="section-title">筛选条件</h4>
              <el-radio-group v-model="tableState" @input="findItem" class="filter-group">
                <el-radio-button label="returned">已退样</el-radio-button>
                <el-radio-button label="supplied">已补样</el-radio-button>
                <el-radio-button label="expired">已过期</el-radio-button>
                <el-radio-button label="reportLosses">已报损</el-radio-button>
                <el-radio-button label="expiring">临期</el-radio-button>
              </el-radio-group>
            </div>
            
            <div class="search-section" v-if="tableState!=''">
              <div class="search-box">
                <el-input
                  v-model="tableSearch"
                  placeholder="输入关键字搜索"
                  size="medium"
                  clearable
                  prefix-icon="el-icon-search"
                />
              </div>
              <div class="table-info">
                <el-tag type="info" size="small" class="table-count">
                  共 {{ items.length }} 条记录
                </el-tag>
              </div>
            </div>
          </div>
          
          <el-table
            :data="items.filter(data => !tableSearch || data.name.toLowerCase().includes(tableSearch.toLowerCase()) ||data.brand.toLowerCase().includes(tableSearch.toLowerCase())||data.properties.toLowerCase().includes(tableSearch.toLowerCase()) )"
            :max-height="tableHight"
            :empty-text="loadInfo"
            class="goods-table"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <div class="expand-content">
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <div class="detail-item">
                        <label>品牌名称:</label>
                        <span>{{ props.row.brand || '-' }}</span>
                      </div>
                      <div class="detail-item">
                        <label>商品名称:</label>
                        <span>{{ props.row.name || '-' }}</span>
                      </div>
                      <div class="detail-item">
                        <label>所属店铺:</label>
                        <span>{{ props.row.shop || '-' }}</span>
                      </div>
                      <div class="detail-item">
                        <label>商品属性:</label>
                        <span>{{ props.row.properties || '-' }}</span>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="detail-item">
                        <label>商品规格:</label>
                        <span>{{ props.row.specs || '-' }}</span>
                      </div>
                      <div class="detail-item">
                        <label>商品位置:</label>
                        <span>{{ props.row.location || '-' }}</span>
                      </div>
                      <div class="detail-item">
                        <label>直播价:</label>
                        <span class="price">{{ props.row.lowPrice || '-' }}</span>
                      </div>
                      <div class="detail-item">
                        <label>已拥有资源:</label>
                        <span>{{ props.row.hasString || '-' }}</span>
                      </div>
                    </el-col>
                  </el-row>
                  <div class="detail-item full-width" v-if="props.row.description">
                    <label>商品描述:</label>
                    <span>{{ props.row.description }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="品牌名称"
              prop="brand"
              min-width="20%"
            >
              <template slot-scope="{ row }">
                <el-tag v-if="row.brand" size="small" type="primary">
                  {{ row.brand }}
                </el-tag>
                <span v-else class="empty-text">-</span>
              </template>
            </el-table-column>

            <el-table-column
              label="商品名称"
              prop="name"
              min-width="30%"
            >
              <template slot-scope="{ row }">
                <div class="name-cell">
                  <span class="product-name">{{ row.name || '-' }}</span>
                  <span class="product-shop" v-if="row.shop">{{ row.shop }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="属性"
              prop="properties"
              min-width="20%"
            >
              <template slot-scope="{ row }">
                <el-tag v-if="row.properties" size="small" type="info">
                  {{ row.properties }}
                </el-tag>
                <span v-else class="empty-text">-</span>
              </template>
            </el-table-column>

            <el-table-column
              v-if="this.tableState !== 'returned' && this.tableState !== 'supplied'"
              label="过期时间"
              prop="exp"
              min-width="15%"
            />

            <el-table-column label="操作" width="120" fixed="right">
              <template slot-scope="scope">
                <el-button 
                  size="mini" 
                  type="primary" 
                  icon="el-icon-edit"
                  @click="update(scope.$index, scope.row)"
                >
                  修改
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { goodsApi } from '@/api'
export default {
  name: 'GoodsView',
  data () {
    return {
      tableHight: window.innerHeight * 0.65,
      tableState: '',
      loadInfo: '暂无数据',
      items: [],
      tableSearch: ''
    }
  },
  mounted () {
  },
  methods: {
    update (index, row) {
      const routeUrl = this.$router.resolve({
        path: '/update',
        query: {
          id: row.id
        }
      })
      window.open(routeUrl.href, '_blank')
      console.log(row.id)
    },
    async findItem () {
      this.items = []
      let state = 0
      if (this.tableState === 'returned') state = 1
      if (this.tableState === 'expiring') state = 2
      if (this.tableState === 'supplied') state = 3
      if (this.tableState === 'reportLosses') state = 4
      this.loadInfo = '数据加载中'

      try {
        const response = await goodsApi.getByState(state)
        this.loadInfo = '数据加载完毕，暂无数据'
        this.items = response
        for (let i in this.items) {
          let hasList = this.items[i].has
          this.items[i].hasString = hasList.join(' · ')
        }
      } catch (error) {
        console.error('获取商品列表失败:', error)
        this.$message.error('获取商品列表失败')
      }
    }
  }
}
</script>
<style scoped>
/* 主容器 */
.goods-view-container {
  padding: 40px;
  background-color: #ffffff;
  min-height: 100vh;
}

/* 内容区域 */
.content-area {
  max-width: 1600px;
  margin: 0 auto;
}

/* 卡片样式 */
.table-card {
  border-radius: 16px;
  margin-bottom: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.card-header {
  padding: 30px 0;
  border-bottom: 2px solid #EBEEF5;
  margin-bottom: 30px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px 16px 0 0;
}

.card-title {
  font-size: 22px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* 筛选头部区域 */
.filter-header {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
}

.filter-section {
  padding: 20px 0;
  border-bottom: 1px solid #EBEEF5;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 15px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-title::before {
  content: '';
  width: 4px;
  height: 16px;
  background: linear-gradient(135deg, #409EFF 0%, #66B1FF 100%);
  border-radius: 2px;
  box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);
}

.filter-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* 搜索区域 */
.search-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 15px 0;
}

.search-box {
  flex: 1;
  max-width: 300px;
}

.table-info {
  display: flex;
  align-items: center;
}

/* 表格区域 */
.table-section {
  padding: 0 40px 40px;
}

/* 表格样式 */
.goods-table {
  border-radius: 8px;
}

.name-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.product-name {
  font-weight: 500;
  color: #303133;
}

.product-shop {
  font-size: 12px;
  color: #909399;
}

.empty-text {
  color: #C0C4CC;
  font-style: italic;
}

/* 展开内容 */
.expand-content {
  padding: 20px;
  background-color: #FAFAFA;
  border-radius: 8px;
  margin: 10px;
}

.detail-item {
  display: flex;
  margin-bottom: 12px;
  align-items: flex-start;
}

.detail-item.full-width {
  flex-direction: column;
  gap: 8px;
}

.detail-item label {
  font-weight: 500;
  color: #606266;
  min-width: 80px;
  margin-right: 12px;
}

.detail-item span {
  color: #303133;
  flex: 1;
}

.detail-item .price {
  color: #F56C6C;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .goods-view-container {
    padding: 10px;
  }
  
  .search-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .search-box {
    width: 100%;
    max-width: none;
  }
  
  .filter-group {
    flex-direction: column;
    gap: 8px;
  }
  
  .filter-header {
    gap: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/goods/GoodsView.vue